import { convertYearInputToPayload } from '../../../functions/convert';

export const updateTrack = (value) => {
  return {
    claimId: value.claimId,
    shippingId: value.shippingId,
    trackingNumber: value.trackingNumber,
    shippingDate: convertYearInputToPayload(value.shippingDate),
  };
};

export const UpdateExcel = (values) => {
  const formData = new FormData();

  formData.append('shippingId', values.shippingId);
  if (values?.excelFile && values.excelFile.length > 0) {
    const file = values.excelFile[0];
    if (file.originFileObj) {
      formData.append('excelFile', file.originFileObj);
    }
  }

  return formData;
};
